import React from "react";
import {
  MButton2,
  MInput,
  MSearchUniversity,
  MSelect,
  ValidatedForm,
} from "components/forms";
import { payloadBuilder } from "libs";
import { FormRef2TitleStep1 } from "./FormRef2TitleStep1";

export class DichiarazioneLaureando extends ValidatedForm {
  constructor(props) {
    super(props);

    // bind event handler to invoke it from the child component
    this.onChange = this.onChange.bind(this);
  }

  emptyFields = {
    extCode: "",
    istitution: "",
    city: "",
    aa: "",
    description: "",
    votoTitolo: "",
    baseVote: "30",
    dataConseguimento: "",
  };

  state = {
    currentExtCode: "",
    showSearchUniversity: false,
    _formRef2_1_1: null,
    loading: true,
    ...this.emptyFields,
    defaultValues: {
      ...this.emptyFields,
    },
    defaultValuesTriennale: {},
  };

  PAYLOADS = {
    qualificationTitle: [
      { label: "Seleziona un Titolo", value: "" },
      ...this.props.payloadTitle,
    ],
  };

  onChangeExtCode = (field, value) => {
    this.setState({ currentExtCode: value });
  };

  FIELDS_GROUP = [
    [
      {
        id: "searchUniversity011",
        component: MButton2,
        onClick: (e) => {
          this.searchUniversity(e);
        },
        label: "Cerca Ateneo",
        className: "col-md-12 mb-3",
        classElement: "btn btn-primary bg-dark",
      },
    ],
    [
      {
        id: "istitution011",
        field: "istitution",
        label: "Presso Ateneo",
        component: MInput,
        type: "text",
        className: "col-md-6 mt-4",
        readOnly: true,
      },
      {
        id: "city011",
        field: "city",
        label: "Città",
        component: MInput,
        type: "text",
        className: "col-md-6 mt-4",
        readOnly: true,
      },
    ],
    [
      {
        id: "description011",
        field: "description",
        label: "Titolo di studio",
        payload: { options: this.PAYLOADS.qualificationTitle },
        component: MSelect,
        className: "col-md-12",
      },
    ],
    [
      {
        id: "extCode011",
        field: "extCode",
        label: "Tipo di laurea",
        component: MSelect,
        payload: {
          options: [
            { value: "", label: "Seleziona il tipo di laurea" },
            {
              value: "LAU_02_270",
              label: "Laurea DM 270/2004 magistrale biennale",
            },
            {
              value: "LAU_CU_270",
              label: "Laurea DM 270/2004 magistrale a ciclo unico",
            },
          ],
        },
        onChange: this.onChangeExtCode,
        className: "col-md-12",
      },
    ],
    [
      {
        id: "aa011",
        field: "aa",
        label: "Anno Accademico prima immatricolazione",
        component: MInput,
        infoText: "inserire formato AAAA/AAAA",
        className: "col-md-6",
      },
      {
        id: "dataLaureaPrevista011",
        field: "dataConseguimento",
        label: "Data di Laurea prevista",
        component: MInput,
        type: "date",
        className: "col-md-6",
        infoText: "limite data massima prevista il 31/05/2026",
      },
    ],
    [
      {
        id: "votoTitolo011",
        field: "votoTitolo",
        label: "Votazione media ponderata conseguita",
        component: MInput,
        type: "text",
        className: "col-md-6",
      },
      {
        id: "baseVote011",
        field: "baseVote",
        label: "Base Voto",
        component: MInput,
        type: "text",
        className: "col-md-6",
        readOnly: true,
      },
    ],
  ];

  ERROR_MESSAGES = {
    extCode: "Dato obbligatorio",
    istitution: "Dato obbligatorio",
    city: "",
    aa: "Dato obbligatorio",
    description: "Dato obbligatorio",
    votoTitolo:
      "Dato non valido. Inserire un numero tra 18 e 30. Valori decimali devono essere inseriti utilizzando un punto come separatore (Esempio: 28.52)",
    dataConseguimento: "Dato obbligatorio. Specificare una data futura",
  };

  validation = {
    extCode: (value) => value !== "",
    istitution: (value) => value !== "",
    city: (value) => value !== "",
    aa: (value) => this.validateAA(value),
    description: (value) => value !== "",
    votoTitolo: (value) =>
      value !== "" && !isNaN(value) && value >= 18 && value <= 30,
    dataConseguimento: (value) => this.validateDataConseguimento(value),
  };

  validateDataConseguimento = (value) => {
    if (value === "") {
      return false;
    }
    let regex = /^\d{4}-\d{2}-\d{2}$/;

    if (!value.match(regex)) {
      return false;
    }

    //--- --- not in the past
    const today = new Date();
    const formDate = new Date(value);

    if (formDate < today) {
      return false;
    }

    const maxDate = new Date("2026-05-31");
    if (formDate > maxDate) {
      return false;
    }

    return true;
  };

  validateAA = (value) => {
    //--- reset dataConseguimento ---
    this.setState({ dataConseguimento: "" });

    let aa = /^(\d{4})\/(\d{4})$/.test(value);

    if (!aa) {
      return false;
    } else {
      aa = value.split("/");

      const currentYear = new Date().getFullYear();
      if (parseInt(aa[1]) > currentYear) {
        return false;
      }

      if (parseInt(aa[1]) === parseInt(aa[0]) + 1) {
        return true;
      } else {
        return false;
      }
    }
  }; //validateAA

  componentDidMount() {
    const { defaultPayload } = this.props;

    const _formRef2_1_1 = React.createRef();
    this.setState({ _formRef2_1_1 });

    const laureando = defaultPayload.laureando || {};
    const laureaTriennale = defaultPayload.laureaTriennale || {};

    this.setState({
      defaultValuesTriennale: laureaTriennale,
    });

    if (Object.keys(laureando).length > 0) {
      const university = {
        city: laureando.city,
        istitution: laureando.istitution,
        uniCode: laureando.uniCode,
      };

      this.setState({
        defaultValues: { ...this.emptyFields, ...laureando },
        currentExtCode: laureando.extCode,
        ...laureando,
        showSearchUniversity: false,
        university,
      });
    }
  }

  searchUniversity = () => {
    this.setState({ showSearchUniversity: !this.state.showSearchUniversity });
  };

  onChangeUniversity = (university) => {
    this.onChange("city", university.city);
    this.onChange("istitution", university.istitution);
    this.setState({
      showSearchUniversity: false,
      university: university,
    });
  };

  onSubmit = () => {
    const isValidA = this.checkValidation();
    let isValidB = true;

    const { _formRef2_1_1 } = this.state;
    if (_formRef2_1_1 && _formRef2_1_1.current) {
      isValidB = _formRef2_1_1.current.checkValidation();
    }

    return isValidA && isValidB;
  };

  getFormLabel = () => {
    return "Laureando";
  };

  getPayload = () => {
    const payloads = [];

    this.payload = payloadBuilder(this.state);
    this.payload.qualificationCode = "title11";
    this.payload.qualificationType = "title11Laureando";
    this.payload.classeConcorso = this.props.competitionClass;
    this.payload.template = "LAUR_RIS_LAU_MAG";

    this.payload.uniCode = this.state.university.uniCode;
    payloads.push(this.payload);

    const { _formRef2_1_1 } = this.state;
    if (_formRef2_1_1 && _formRef2_1_1.current) {
      payloads.push(_formRef2_1_1.current.getPayload());
    }

    return payloads;
  };

  //--- ---

  render() {
    const {
      defaultValues,
      defaultValuesTriennale,
      showSearchUniversity,
      currentExtCode,
      _formRef2_1_1,
    } = this.state;

    const fields = this.FIELDS_GROUP;
    const { code } = this.renderFields(fields, defaultValues, true);

    return (
      <>
        <p>
          Iscritto all'ultimo anno della Laurea Magistrale o Magistrale a ciclo
          unico o Diploma Accademico di II livello. L'accesso, per gli iscritti
          ai corsi di studio per il conseguimento della Laurea Magistrale a
          ciclo unico, è subordinato al conseguimento di almeno 180 CFU.{" "}
        </p>
        <p>
          Consapevole che l'accesso alla prova finale del Percorso è consentito
          solo a coloro che hanno già conseguito il titolo di studio per
          l'accesso alla relativa classe di concorso e che integrerò la
          documentazione al momento del conseguimento titolo.
        </p>
        {showSearchUniversity && (
          <>
            <MSearchUniversity
              onChange={this.onChangeUniversity}
              searchUniversity={this.searchUniversity}
            />
          </>
        )}

        {!showSearchUniversity && <form className="user mt-4">{code}</form>}
        {currentExtCode === "LAU_02_270" && (
          <>
            <h4>Informazioni sulla tua laurea triennale:</h4>
            <FormRef2TitleStep1
              ref={_formRef2_1_1}
              defaultPayload={defaultValuesTriennale}
            />
          </>
        )}
      </>
    );
  }
}
